import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import ToDoList from '../Dashboard/ToDoList';
import { CLOUD_ICON, DIY_ICON } from '../../config/media';
import { Wrapper } from './style';

export const RenderTodo = ({ exchange, handleClose, isPlugin }) => {
    return (
        <Wrapper>
            <div className="helper-modal-wrapper">
                <div className="plugin-title">{isPlugin ? `Plugin Installation` : `Going live with your cloud exchange`}</div>
                <div className="flex-center">
                    <div>
                        <img src={exchange.type === "Cloud" ? CLOUD_ICON : DIY_ICON} alt="cloud" className="cloud-icon" />
                    </div>
                    <div>
                        <b>Hosting type:</b>{' '}{exchange.type}
                    </div>
                </div>
                <div className="description">{isPlugin ? `In order to install plugins you need to first go live with your exchange:` : `In order to make your exchange live with your domain you must complete your to do list below:`}
                </div>
                <div>
                    <div><b>To do list</b></div>
                    <ToDoList exchange={exchange} showApplyUpdate={false} />
                </div>
                <div className="flex-space-between btn-wrapper">
                    <Button type='primary' className="back-btn" onClick={handleClose}>Back</Button>
                    <div className="separator"></div>
                    <Link to="/hosting" className="back-btn">
                        <Button type="primary" className="back-btn" onClick={handleClose}>Go to hosting</Button>
                    </Link>
                </div>
            </div>
        </Wrapper>
    )
};